// extracted by mini-css-extract-plugin
export default {"item":"BidsList_item__Y0cyF","list":"BidsList_list__R1COi","mine":"BidsList_mine__6+yqh"};